'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _recompose = require('recompose');

var _Icon = require('../../../components/icons/Icon');

var _Icon2 = _interopRequireDefault(_Icon);

require('./BoardStatus.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getStatusIcon = function getStatusIcon(_ref) {
    var isShared = _ref.isShared,
        isLinkAlias = _ref.isLinkAlias;
    // eslint-disable-line react/prop-types
    if (isLinkAlias) {
        return _react2.default.createElement(_Icon2.default, { name: 'board-link' });
    } else if (isShared) {
        return _react2.default.createElement(_Icon2.default, { name: 'board-shared-users' });
    }
}; // Lib


var BoardStatus = function BoardStatus(props) {
    var statusIcon = getStatusIcon(props);
    if (!statusIcon) return null;

    return _react2.default.createElement(
        'div',
        { className: 'BoardStatus' },
        _react2.default.createElement('div', { className: 'board-status-bg' }),
        statusIcon
    );
};

BoardStatus.propTypes = {
    isShared: _propTypes2.default.bool,
    isLinkAlias: _propTypes2.default.bool
};

exports.default = (0, _recompose.pure)(BoardStatus);


//////////////////
// WEBPACK FOOTER
// ./src/client/element/board/boardIcon/BoardStatus.js
// module id = 1954
// module chunks = 0